import { lazy } from 'react'

const UserDashboard = lazy(async () => {
  const { Dashboard } = await import(
    /* webpackChunkName: "navigator-dashboard" */ './index'
  )

  return {
    default: Dashboard
  }
})
const routes = [
  {
    path: '/',
    exact: true,
    render(props) {
      return <UserDashboard {...props} />
    }
  }
]

export { routes }
